import { VoieDeRecours } from './sections/voies-de-recours.jsx'
import { RetourInfoContact } from './sections/retour-info-contact.jsx'
import { Plan } from './sections/plan.jsx'
import { NonConformite } from './sections/non-conformite.jsx'
import { Fragment } from 'preact'

export const Done = (data) => {
  const {
    approval = { name: '' },
    audit_date = '',
    audit_updatedate = '',
    compliantStateComment = '',
    contact = { name: '', content: '' },
    derogations = '',
    details = { detail: [] },
    environments = { environment: [] },
    exemptions = '',
    nonComplianceComment = '',
    pages_results = { page: [] },
    plan = '',
    referential = { name: '', version: '', level: '' },
    results = { result: [] },
    technologies = { technology: [] },
    tests = { test: [] },
    title = '',
    urls = { url: [] },
  } = data

  return (
    <div class="site-width">
      <div class="container-fluid">
        <div class="header-wrapper mb-2 mb-md-3">
          <div class="container-fluid">
            <h1 class="pb-0 mt-1 mt-md-2 mb-1 mb-md-2">Déclaration d'accessibilité : {title}</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-8">
            <Plan plan={plan} title={title} />

            <h2 class="mb-1">Etat de conformité</h2>

            <ConformityText conformity={pages_results.conformity} referential={referential} title={title} isExpired={isExpiredAudit(audit_date, audit_updatedate)} />

            {compliantStateComment !== '' ? <div dangerouslySetInnerHTML={{ __html: compliantStateComment }}></div> : ''}

            {isExpiredAudit(audit_date, audit_updatedate) && (
              <Fragment>
                <p>Pour information, voici les résultats de la précédente déclaration établie le {dateFormater(audit_date)}.</p>
              </Fragment>
            )}

            <p>
              Orange utilise une autre méthode de test que le{' '}
              <abbr title="Référentiel général d'amélioration de l'accessibilité" style="speak: spell-out;">
                RGAA
              </abbr>
              , les{' '}
              <abbr lang="en" title="Web Content Accessibility Guidelines" style="speak: spell-out;">
                WCAG
              </abbr>{' '}
              version 2.2 niveaux A et AA. <br />
              <a
                href="https://a11y-guidelines.orange.com/fr/cadrage/correspondance-rgaa-wcag/"
                target="_blank"
                title="Consulter le tableau de correspondance entre les RGAA et les WCAG (nouvelle fenêtre)"
              >
                Consulter le tableau de correspondance entre les{' '}
                <abbr title="Référentiel général d'amélioration de l'accessibilité" style="speak: spell-out;">
                  RGAA
                </abbr>{' '}
                et les{' '}
                <abbr lang="en" title="Web Content Accessibility Guidelines" style="speak: spell-out;">
                  WCAG
                </abbr>
                .
              </a>
            </p>

            <p>
              L'audit a été effectué via la{' '}
              <a href="https://la-va11ydette.orange.com/" target="_blank" title="Va11ydette d'Orange (nouvelle fenêtre)">
                Va11ydette d'Orange.
              </a>
            </p>

            <h3 class="h3 mb-1 mt-2">Résultat des tests</h3>
            <div class="d-flex mt-1 mb-2">
              <div class="text-center">
                <h4 class="pie" data-value={global_conformity(results)}>
                  <div class="pie-val">
                    <span class="sr-only">Conformité globale</span>
                    <span>{global_conformity(results)}%</span>
                  </div>
                </h4>
                <strong class="mt-1 d-block" aria-hidden="true">
                  Conformité globale
                </strong>
              </div>
              <div class="ml-3 text-center">
                <h4 class="pie" data-value={pages_results.conformity}>
                  <div class="pie-val">
                    <span class="sr-only">Conformité moyenne</span>
                    <span>{pages_results.conformity}%</span>
                  </div>
                </h4>
                <strong class="mt-1 d-block" aria-hidden="true">
                  Conformité moyenne
                </strong>
              </div>
            </div>
            <p>L'audit de conformité réalisé en interne par {approval.name} révèle que&nbsp;:</p>
            <ul class="list">
              <li>
                {global_conformity(results)}% des critères{' '}
                <abbr lang="en" title="Web Content Accessibility Guidelines" style="speak: spell-out;">
                  WCAG
                </abbr>{' '}
                de niveau A et AA sont respectés.
              </li>
              <li>Le taux moyen de conformité du service en ligne s'élève à {pages_results.conformity}%.</li>
            </ul>
          </div>

          <div class="col-12 col-md-8 col-lg-6">
            <h4 class="h3 mb-1 mt-3" id="title-table-synthesis">
              Synthèse par niveau
            </h4>
            <table class="table" aria-labelledby="title-table-synthesis" dangerouslySetInnerHTML={{ __html: synthesis_table(results) }}></table>
          </div>

          <div class="col-12">
            <h4 class="h3 mb-1 mt-3" aria-hidden="true" id="title-table-taux">
              Taux de conformité par page selon les deux niveaux de critères A et AA
            </h4>
            <div class="slider-table">
              <table class="table" aria-labelledby="title-table-taux">
                <caption class="sr-only">Taux de conformité par page selon les deux niveaux de critères A et AA</caption>
                <thead>
                  <tr>
                    <th scope="row">Critères/Niveau</th>
                    <th scope="col">
                      Conforme / <span aria-hidden="true">A</span>
                      <span class="sr-only leftZero">Niveau un A</span>
                    </th>
                    <th scope="col">
                      Conforme / <span aria-hidden="true">AA</span>
                      <span class="sr-only leftZero">Niveau deux A</span>
                    </th>
                    <th scope="col">
                      Non conforme / <span aria-hidden="true">A</span>
                      <span class="sr-only leftZero">Niveau un A</span>
                    </th>
                    <th scope="col">
                      Non conforme / <span aria-hidden="true">AA</span>
                      <span class="sr-only leftZero">Niveau deux A</span>
                    </th>
                    <th scope="col">
                      Non applicable / <span aria-hidden="true">A</span>
                      <span class="sr-only leftZero">Niveau un A</span>
                    </th>
                    <th scope="col">
                      Non applicable / <span aria-hidden="true">AA</span>
                      <span class="sr-only leftZero">Niveau deux A</span>
                    </th>
                    <th scope="col">Taux de conformité</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(pages_results.page) ? (
                    pages_results.page.map((page) => (
                      <tr>
                        <th scope="row">{page.name}</th>
                        <td>{page.ok[0]['_']}</td>
                        <td>{page.ok[1]['_']}</td>
                        <td>{page.nok[0]['_']}</td>
                        <td>{page.nok[1]['_']}</td>
                        <td>{page.na[0]['_']}</td>
                        <td>{page.na[1]['_']}</td>
                        <td>{page.conformity}%</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <th scope="row">{pages_results.page.name}</th>
                      <td>{pages_results.page.ok[0]['_']}</td>
                      <td>{pages_results.page.ok[1]['_']}</td>
                      <td>{pages_results.page.nok[0]['_']}</td>
                      <td>{pages_results.page.nok[1]['_']}</td>
                      <td>{pages_results.page.na[0]['_']}</td>
                      <td>{pages_results.page.na[1]['_']}</td>
                      <td>{pages_results.page.conformity}%</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-12 col-md-8">
            <h2 class="mt-2 mb-1 mt-md-3">Contenus non accessibles</h2>
            <p>Les contenus listés ci-dessous ne sont pas accessibles pour les raisons suivantes&nbsp;:</p>

            {details !== '' && <NonConformite details={details} nonComplianceComment={nonComplianceComment} />}

            <h3 class="h3 mb-1 mt-2">Dérogations pour charge disproportionnée</h3>
            <p>{derogations !== '' ? derogations : '(Aucune)'}</p>

            <h3 class="h3 mb-1 mt-2">Contenus non soumis à l'obligation d'accessibilité</h3>
            <p>{exemptions !== '' ? exemptions : '(Aucune)'}</p>

            <h2 class="mb-1 mt-2">Établissement de cette déclaration d'accessibilité</h2>
            <p>
              Cette déclaration a été établie le {dateFormater(audit_date)}. {audit_updatedate !== '' ? `Elle a été mise à jour le ${dateFormater(audit_updatedate)}.` : ''}
            </p>

            <h3 class="h3 mb-1 mt-2">Technologies utilisées pour la réalisation du site web</h3>
            <ul class="list">
              {Array.isArray(technologies.technology) ? (
                technologies.technology.map((tech) => {
                  return <li>{tech}</li>
                })
              ) : (
                <li>{technologies.technology}</li>
              )}
            </ul>

            <h3 class="h3 mb-1 mt-2">Environnement de test</h3>
            <p>Agents utilisateurs, technologies d'assistance et outils utilisés pour vérifier l'accessibilité</p>
            <ul class="list">
              {Array.isArray(environments.environment) ? (
                environments.environment.map((env) => {
                  return <li>{env}</li>
                })
              ) : (
                <li>{environments.environment}</li>
              )}
            </ul>

            <h3 class="h3 mb-1 mt-2">Outils utilisés lors de l'évaluation</h3>
            <ul class="list">
              {groupTestsByType(tests.test).map((test) => {
                return (
                  <li>
                    <strong>{test.type}</strong> : {test.outils}
                  </li>
                )
              })}
            </ul>

            <h3 class="h3 mb-1 mt-2">Page(s) ayant fait l'objet de la vérification de conformité</h3>
            <p>
              L'audit de vérification a été effectué sur les pages suivantes à l'aide de la <a href="https://la-va11ydette.orange.com/">va11ydette d'Orange</a>.
            </p>
            <ul class="list">
              {Array.isArray(urls.url) ? (
                urls.url.map((url) => {
                  return (
                    <li>
                      {url.location ? (
                        <a href={url.location} target="_blank" title={`${url.name} (nouvelle fenêtre)`}>
                          {url.name}
                        </a>
                      ) : (
                        <span>{url.name}</span>
                      )}
                    </li>
                  )
                })
              ) : (
                <li>
                  {urls.url.location ? (
                    <a href={urls.url.location} target="_blank" title={`${urls.url.name} (nouvelle fenêtre)`}>
                      {urls.url.name}
                    </a>
                  ) : (
                    <span>{urls.url.name}</span>
                  )}
                </li>
              )}
            </ul>

            <RetourInfoContact {...contact} />

            <VoieDeRecours />
          </div>
        </div>
      </div>
    </div>
  )
}

const ConformityText = ({ conformity, referential, title, isExpired }) => {
  let conformityInt = parseInt(conformity)
  let level = referential.level === 'A' ? 'A' : 'A et AA'
  switch (true) {
    case conformityInt === 100 && !isExpired:
      return (
        <p>
          {title} est totalement conforme aux critères {referential.name} version {referential.version} de niveau {level}, en raison des dérogations énumérées ci-dessous.
        </p>
      )
    case conformityInt >= 50 && !isExpired:
      return (
        <p>
          {title} est partiellement conforme aux critères {referential.name} version {referential.version} de niveau {level}, en raison des non-conformités et des dérogations
          énumérées ci-dessous.
        </p>
      )
    case conformityInt < 50 && !isExpired:
      return (
        <Fragment>
          <p>
            {title} est non conforme aux critères {referential.name} version {referential.version} de niveau {level}, en raison des non-conformités et des dérogations énumérées
            ci-dessous.
          </p>
        </Fragment>
      )
    case isExpired:
      return (
        <Fragment>
          <p>
            {title} est non conforme aux critères {referential.name} version {referential.version} de niveau {level}, car il n'existe aucun résultat d'audit de conformité en cours
            de validité.
          </p>
        </Fragment>
      )
  }
}

const isExpiredAudit = (auditDate, updateDate) => {
  const THREE_YEARS_IN_MS = 3 * 365 * 24 * 60 * 60 * 1000 // 3 years in milliseconds
  const now = new Date()

  let comparisonDate
  if (updateDate) {
    comparisonDate = new Date(updateDate)
  } else {
    comparisonDate = new Date(auditDate)
  }

  return now.getTime() - comparisonDate.getTime() > THREE_YEARS_IN_MS
}

const global_conformity = (results) => {
  let total = 0
  results.result.forEach((result) => {
    if (result.type === 'total') {
      total = result.conformity
    }
  })
  return total
}

const synthesis_table = (results) => {
  // En-têtes de table
  let html = '<thead><tr><th scope="row">Niveau</th>'
  results.result.forEach((item) => {
    let displayType
    if (item.type === 'a') {
      displayType = '<span aria-hidden="true">A</span><span class="sr-only">Niveau un A</span>'
    } else if (item.type === 'aa') {
      displayType = '<span aria-hidden="true">AA</span><span class="sr-only">Niveau deux A</span>'
    } else if (item.type === 'total') {
      displayType = item.type.charAt(0).toUpperCase() + item.type.slice(1)
    } else {
      displayType = item.type
    }
    html += `<th scope="col">${displayType}</th>`
  })
  html += '</tr></thead><tbody>'

  // Lignes de table
  let rows = [
    { data: 'criteria', label: 'Nombre de critères' },
    { data: 'ok', label: 'Conforme' },
    { data: 'nok', label: 'Non conforme' },
    { data: 'na', label: 'Non applicable' },
    { data: 'conformity', label: 'Conformité' },
  ]
  rows.forEach((row) => {
    html += `<tr><th scope="row">${row.label}</th>`
    results.result.forEach((item) => {
      html += `<td>${item[row.data]}${row.data === 'conformity' ? '%' : ''}</td>`
    })
    html += '</tr>'
  })
  html += '</tbody>'
  return html
}

const dateFormater = (date) => {
  let parts = date.split('-')
  let newDate = `${parts[2]}/${parts[1]}/${parts[0]}`
  return newDate
}

const groupTestsByType = (tests) => {
  let groupedTests = {}

  tests.forEach((test) => {
    let type
    switch (test.type) {
      case 'auto':
        type = 'Tests automatiques'
        break
      case 'manual':
        type = 'Tests manuels'
        break
      case 'functional':
        type = 'Tests fonctionnels'
        break
      default:
        type = test.type
    }

    if (!groupedTests[type]) {
      groupedTests[type] = []
    }
    groupedTests[type].push(`${test.name} ${test.version}`)
  })

  let result = []
  for (let type in groupedTests) {
    result.push({ type: type, outils: groupedTests[type].join(', ') })
  }

  return result
}
